/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_Title_TailInputs */

const en_platform_plan_title_tail = /** @type {(inputs: Platform_Plan_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In minutes.`)
};

const pl_platform_plan_title_tail = /** @type {(inputs: Platform_Plan_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W kilka minut.`)
};

/**
* | output |
* | --- |
* | "In minutes." |
*
* @param {Platform_Plan_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_title_tail = /** @type {((inputs?: Platform_Plan_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_title_tail(inputs)
	return en_platform_plan_title_tail(inputs)
});